'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Loader = require('./Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _Icons = require('./Icons');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (0, _react.memo)(function (_ref) {
	var label = _ref.label,
	    disabled = _ref.disabled,
	    loading = _ref.loading,
	    type = _ref.type,
	    className = _ref.className,
	    size = _ref.size,
	    fullWidth = _ref.fullWidth,
	    to = _ref.to,
	    target = _ref.target,
	    theme = _ref.theme,
	    children = _ref.children,
	    asLink = _ref.asLink,
	    onClick = _ref.onClick,
	    asSpan = _ref.asSpan,
	    complete = _ref.complete,
	    icon = _ref.icon,
	    iconPosition = _ref.iconPosition;


	var renderLabel = function renderLabel() {
		if (loading) return _react2.default.createElement(_Loader2.default, null);

		if (complete) return _react2.default.createElement(
			'span',
			{ className: 'bnc_field_button_success' },
			_react2.default.createElement(_Icons.CheckFat, null)
		);

		return _react2.default.createElement(
			_react.Fragment,
			null,
			icon && iconPosition === "left" && _react2.default.createElement(
				'span',
				{ className: 'ico ico--left' },
				icon
			),
			_react2.default.createElement(
				'span',
				{ className: 'label' },
				children || label
			),
			icon && iconPosition === "right" && _react2.default.createElement(
				'span',
				{ className: 'ico ico--right' },
				icon
			)
		);
	};

	var css = (0, _classnames2.default)('bnc_field_button', className, 'theme--' + theme, 'size--' + size, {
		'--disabled': disabled || loading,
		'--full-width': fullWidth
	});

	if (asSpan) {
		return _react2.default.createElement(
			'span',
			{ className: css },
			_react2.default.createElement(
				'span',
				null,
				renderLabel()
			)
		);
	}

	if (to && to !== '' || asLink) {
		var aProps = Object.assign({}, to && to !== '' ? { href: to } : null, target ? { target: target } : null, target && target === "_blank" ? { rel: 'noopener noreferrer' } : null, onClick ? { onClick: onClick } : null);
		return _react2.default.createElement(
			'a',
			_extends({
				className: css
			}, aProps),
			_react2.default.createElement(
				'span',
				null,
				renderLabel()
			)
		);
	}

	var bProps = Object.assign({}, type ? { type: type } : null, onClick ? { onClick: onClick } : null);

	return _react2.default.createElement(
		'button',
		_extends({
			className: css,
			disabled: disabled || loading
		}, bProps),
		_react2.default.createElement(
			'span',
			null,
			renderLabel()
		)
	);
});

Button.defaultProps = {
	disabled: false,
	label: '',
	type: 'button',
	loading: false,
	complete: false,
	className: '',
	dense: false,
	to: '',
	size: 'regular',
	theme: 'pink',
	target: null,
	fullWidth: false,
	asLink: false,
	asSpan: false,
	icon: null,
	iconPosition: "left"
};

Button.propTypes = {
	onClick: _propTypes2.default.func,
	label: _utils.StringOrReact,
	type: _propTypes2.default.string,
	disabled: _propTypes2.default.bool,
	theme: _propTypes2.default.string,
	loading: _propTypes2.default.bool,
	complete: _propTypes2.default.bool,
	className: _propTypes2.default.string,
	size: _propTypes2.default.string,
	to: _propTypes2.default.string,
	target: _propTypes2.default.string,
	fullWidth: _propTypes2.default.bool,
	asLink: _propTypes2.default.bool,
	asSpan: _propTypes2.default.bool,
	icon: _propTypes2.default.element,
	iconPosition: _propTypes2.default.string
};

exports.default = Button;